import { render, staticRenderFns } from "./app-container.vue?vue&type=template&id=16f04c86"
import script from "./app-container.vue?vue&type=script&lang=js"
export * from "./app-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports